export const LEGACY_TO_NEW_ROUTE_MAP: Record<string, string> = {
  '/events': '/monitoring/events',
  '/license-plate': '/monitoring/license-plate',
}
